import { ReactNode } from 'react'
import styles from './table.module.scss'
import clsx from 'clsx'
import ManualRefreshButton from 'components/ManualRefreshButton/ManualRefreshButton'
import AsyncTypography from 'components/AsyncTypography/AsyncTypography'

interface TableMetaDataProps {
  text: string
  refreshHandler: () => void
  children?: ReactNode
  isRefreshRHS?: boolean
  isInitialising?: boolean
  isLoading?: boolean
  permissions?: {
    canRefresh: boolean
  }
}

function TableMetaDataRow({
  text,
  refreshHandler,
  children,
  isRefreshRHS,
  isInitialising,
  isLoading,
  permissions,
}: TableMetaDataProps) {
  const canRefresh = !!permissions ? permissions?.canRefresh : true
  return (
    <div className={styles.table__metaDataRow}>
      {canRefresh && (
        <>
          <AsyncTypography isLoading={isInitialising} tag="p" type="s-body">
            {text}
          </AsyncTypography>
          <ManualRefreshButton
            refreshHandler={refreshHandler}
            className={clsx(isRefreshRHS && styles.table__metaDataRowRHS)}
            isLoading={isInitialising || isLoading}
          />
        </>
      )}
      {children && <div className={styles.table__metaDataRowRHS}>{children}</div>}
    </div>
  )
}

export default TableMetaDataRow
